'use client'

import { cn } from '@/website/utils/tailwindUtils';
import { ChevronRight } from 'lucide-react';
import Link from 'next/link';
import { useContext } from 'react';
import { ClientSidePartnerContext } from '@/website/context/clientSidePartnerContext';

type Props = {
	pageName: string
}

export const PageBreadCrumb = (props: Props) => {

	const { pageName } = props
	const { clientSidePartner } = useContext(ClientSidePartnerContext)

	const breadcrumbCss = cn(
		'text-base font-(family-name:--ds-secondary-font) font-semibold',
		'svg:hidden not-last:svg:block not-last:flex not-last:items-center not-last:gap-x-(--ds-spacing-xs)',
		'lg:text-lg'
	)

	const partnerSlugNeeded = clientSidePartner.slug !== 'playdia' && clientSidePartner.hostingType !== 'domain' 

	return (
		<section className={cn('mx-auto max-w-[1066px] px-(--ds-spacing-sm) lg:px-10 py-1.5')}>
			<nav className={cn('breadcrumb ')} aria-label="breadcrumb">
				<ol className={cn('breadcrumb__list flex items-center gap-x-1 lg:gap-x-(--ds-spacing-xs)')}>
					<li key={0} className={cn('breadcrumb__crumb', breadcrumbCss)}>
						<Link href={ partnerSlugNeeded ? `/${clientSidePartner.slug}` : '/'} className={cn('hover:text-(--button-primary-background) transition-colors ease-linear duration-300')}>All Games</Link>
						<ChevronRight className={cn('w-5 h-5 text-(--button-primary-background)')} />
					</li>
					<li key={1} className={cn('breadcrumb__crumb__end', breadcrumbCss)}>{pageName}</li>
				</ol>
			</nav>
		</section>
	)
}
